// extracted by mini-css-extract-plugin
export var communityImg = "FeaturedBoard-module--communityImg--e8fd3";
export var content = "FeaturedBoard-module--content--7ac90";
export var figure = "FeaturedBoard-module--figure--0275a";
export var headline = "FeaturedBoard-module--headline--3bf35";
export var link = "FeaturedBoard-module--link--3ef0b";
export var tag = "FeaturedBoard-module--tag--f307a";
export var tagFeatured = "FeaturedBoard-module--tagFeatured--63f49";
export var tagNew = "FeaturedBoard-module--tagNew--6bfcc";
export var text = "FeaturedBoard-module--text--51ec2";
export var wrapper = "FeaturedBoard-module--wrapper--4fbb6";